<template>
  <el-select
    v-model="selectedRecord"
    :remote-method="loadRecords"
    :loading="loading"
    placeholder="Ajoutez un thème..."
    class="select-info flex-grow-1"
    clearable
    filterable
    remote
    reserve-keyword
    @input="$emit('input', $event)"
  >
    <el-option
      v-for="record in records"
      :key="record.profileId"
      :label="record.profileName"
      :value="record.profileId"
      class="select-info"
    >
      <span style="float: left">{{ record.profileName }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">
        {{ record.profileCategory }}
      </span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      loading: false,
      selectedRecord: {},
      records: [],
    };
  },
  methods: {
    loadRecords(query) {
      if (query !== '') {
        this.loading = true;
        this.$http
          .get(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/profileEntities/search/fulltext?category=${query}&name=${query}&page=0&size=10`,
          )
          .then(response => {
            this.loading = false;
            this.records = response.data._embedded.profileEntities;
          });
      } else {
        this.records = [];
      }
    },
  },
};
</script>

<style scoped></style>
